/**
 * 待办提醒：短提示音 + 语音播报
 * 「您有新的待办事项，请及时处理」
 */

const REMIND_TEXT = '您有新的待办事项，请及时处理'
const SPEECH_COOLDOWN_MS = 8000

let audioCtx = null
let unlocked = false
let lastSpeechAt = 0

function getAudioContext() {
  if (typeof window === 'undefined') return null
  const Ctx = window.AudioContext || window.webkitAudioContext
  if (!Ctx) return null
  if (!audioCtx) {
    audioCtx = new Ctx()
  }
  return audioCtx
}

/** 用户首次交互后解锁音频（浏览器自动播放策略） */
export function unlockNotifyAudio() {
  if (unlocked) return
  const ctx = getAudioContext()
  if (!ctx) {
    unlocked = true
    return
  }
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {})
  }
  unlocked = true
}

function playChime() {
  const ctx = getAudioContext()
  if (!ctx) return
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {})
  }
  const now = ctx.currentTime
  const notes = [880, 1174.7] // A5 → D6
  notes.forEach((freq, i) => {
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.type = 'sine'
    osc.frequency.value = freq
    const start = now + i * 0.12
    gain.gain.setValueAtTime(0.0001, start)
    gain.gain.exponentialRampToValueAtTime(0.18, start + 0.02)
    gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.28)
    osc.connect(gain)
    gain.connect(ctx.destination)
    osc.start(start)
    osc.stop(start + 0.3)
  })
}

function speakRemind() {
  if (typeof window === 'undefined' || !window.speechSynthesis) {
    return
  }
  const now = Date.now()
  if (now - lastSpeechAt < SPEECH_COOLDOWN_MS) {
    return
  }
  lastSpeechAt = now
  try {
    window.speechSynthesis.cancel()
    const utter = new SpeechSynthesisUtterance(REMIND_TEXT)
    utter.lang = 'zh-CN'
    utter.rate = 1
    utter.pitch = 1
    utter.volume = 1
    const voices = window.speechSynthesis.getVoices() || []
    const zh = voices.find((v) => /zh(-|_)?CN|Chinese/i.test(v.lang + v.name))
    if (zh) {
      utter.voice = zh
    }
    window.speechSynthesis.speak(utter)
  } catch (err) {
    console.warn('[notifyRemind] 语音播报失败', err)
  }
}

/** 有新待办时调用：提示音 + 语音 */
export function playTodoRemind() {
  try {
    playChime()
  } catch (err) {
    console.warn('[notifyRemind] 提示音失败', err)
  }
  // 稍晚再播报，避开提示音重叠
  setTimeout(() => {
    speakRemind()
  }, 350)
}

export { REMIND_TEXT }
